{
  "title": "الشيكات",
  "detailTitle": "الشيك {{number}}",
  "subtitle": {
    "RECEIVED": "شيكات العملاء، من الصندوق إلى البنك",
    "ISSUED": "الشيكات الصادرة للموردين، حتى يصرفها البنك"
  },
  "sides": {
    "label": "الشيكات الواردة أو الصادرة",
    "RECEIVED": "واردة",
    "ISSUED": "صادرة"
  },
  "kind": {
    "RECEIVED": "شيك وارد",
    "ISSUED": "شيك صادر"
  },
  "views": {
    "label": "عروض الشيكات",
    "open": "قائمة",
    "cleared": "مصروفة",
    "bounced": "مرتجعة",
    "closed": {
      "RECEIVED": "معادة للعملاء",
      "ISSUED": "ملغاة"
    },
    "all": "الكل"
  },
  "searchPlaceholder": "ابحث بالرقم أو البنك أو الطرف…",
  "searchLabel": "البحث في الشيكات",
  "filters": {
    "account": "الحساب"
  },
  "fields": {
    "number": "رقم الشيك",
    "chequeDate": "تاريخ الشيك",
    "supplier": "المورد",
    "receipt": "سند القبض",
    "payment": "سند الدفع",
    "depositAccount": "حساب الإيداع",
    "drawnOn": "مسحوب على",
    "amount": "المبلغ",
    "status": "الحالة",
    "bank": "البنك",
    "depositedOn": "تاريخ الإيداع",
    "clearedOn": "تاريخ الصرف"
  },
  "status": {
    "IN_HAND": "في الصندوق",
    "DEPOSITED": "مودَع",
    "ISSUED": "صادر",
    "CLEARED": "مصروف",
    "BOUNCED": "مرتجع",
    "RETURNED": "معاد للعميل",
    "CANCELLED": "ملغى"
  },
  "due": {
    "OVERDUE": "حلّ تاريخه",
    "TODAY": "يستحق اليوم",
    "SOON": "يستحق هذا الأسبوع",
    "LATER": "مؤجل"
  },
  "dueDeposited": {
    "OVERDUE": "تأخر صرفه",
    "TODAY": "يُصرف اليوم",
    "SOON": "لدى البنك",
    "LATER": "لدى البنك"
  },
  "postDated": "مؤجل",
  "postDatedBy": "شيك مؤجل: يقبله البنك ابتداءً من {{date}}.",
  "figures": "أرقام الشيك",
  "actions": {
    "deposit": "إيداع",
    "clear": "تأكيد الصرف",
    "bounce": "ارتجع",
    "return": "إعادة للعميل",
    "cancel": "إلغاء الشيك",
    "chargeback": "ارتجع بعد الصرف",
    "undo": "التراجع عن آخر خطوة"
  },
  "rowActions": "إجراءات الشيك {{number}}",
  "select": "تحديد الشيك {{number}}",
  "notSelectable": "لا شيء للإيداع أو الصرف",
  "bulk": {
    "deposit_zero": "إيداع {{n}} شيك",
    "deposit_one": "إيداع شيك واحد",
    "deposit_two": "إيداع شيكين",
    "deposit_few": "إيداع {{n}} شيكات",
    "deposit_many": "إيداع {{n}} شيكًا",
    "deposit_other": "إيداع {{n}} شيك",
    "depositHint": "لا يُودَع إلا شيك في الصندوق حلّ تاريخه",
    "clear_zero": "تأكيد صرف {{n}} شيك",
    "clear_one": "تأكيد صرف شيك واحد",
    "clear_two": "تأكيد صرف شيكين",
    "clear_few": "تأكيد صرف {{n}} شيكات",
    "clear_many": "تأكيد صرف {{n}} شيكًا",
    "clear_other": "تأكيد صرف {{n}} شيك",
    "clearHint": "لا يُؤكَّد إلا صرف شيك قائم"
  },
  "toast": {
    "deposit": "أُودِع الشيك {{number}}",
    "clear": "صُرف الشيك {{number}}",
    "bounce": "سُجّل ارتجاع الشيك {{number}}",
    "return": "أُعيد الشيك {{number}} للعميل",
    "cancel": "أُلغي الشيك {{number}}",
    "chargeback": "سُجّل ارتجاع الشيك {{number}} بعد صرفه",
    "undo": "تم التراجع عن آخر خطوة للشيك {{number}}",
    "depositMany_zero": "لم يُودَع أي شيك",
    "depositMany_one": "أُودِع شيك واحد",
    "depositMany_two": "أُودِع شيكان",
    "depositMany_few": "أُودِعت {{count}} شيكات",
    "depositMany_many": "أُودِع {{count}} شيكًا",
    "depositMany_other": "أُودِع {{count}} شيك",
    "clearMany_zero": "لم يُصرف أي شيك",
    "clearMany_one": "صُرف شيك واحد",
    "clearMany_two": "صُرف شيكان",
    "clearMany_few": "صُرفت {{count}} شيكات",
    "clearMany_many": "صُرف {{count}} شيكًا",
    "clearMany_other": "صُرف {{count}} شيك"
  },
  "dialog": {
    "depositTitle": "إيداع الشيك {{number}}",
    "clearTitle": "تأكيد صرف الشيك {{number}}",
    "bounceTitle": "ارتجاع الشيك {{number}}",
    "returnTitle": "إعادة الشيك {{number}} للعميل",
    "cancelTitle": "إلغاء الشيك {{number}}",
    "chargebackTitle": "ارتجاع الشيك {{number}} بعد صرفه",
    "undoTitle": "التراجع عن آخر خطوة للشيك {{number}}",
    "depositManyTitle_zero": "إيداع {{count}} شيك ({{amount}})",
    "depositManyTitle_one": "إيداع شيك واحد ({{amount}})",
    "depositManyTitle_two": "إيداع شيكين ({{amount}})",
    "depositManyTitle_few": "إيداع {{count}} شيكات ({{amount}})",
    "depositManyTitle_many": "إيداع {{count}} شيكًا ({{amount}})",
    "depositManyTitle_other": "إيداع {{count}} شيك ({{amount}})",
    "clearManyTitle_zero": "تأكيد صرف {{count}} شيك ({{amount}})",
    "clearManyTitle_one": "تأكيد صرف شيك واحد ({{amount}})",
    "clearManyTitle_two": "تأكيد صرف شيكين ({{amount}})",
    "clearManyTitle_few": "تأكيد صرف {{count}} شيكات ({{amount}})",
    "clearManyTitle_many": "تأكيد صرف {{count}} شيكًا ({{amount}})",
    "clearManyTitle_other": "تأكيد صرف {{count}} شيك ({{amount}})",
    "depositBody": {
      "RECEIVED": "يبقى المبلغ برسم التحصيل حتى يصرف البنك الشيك؛ لا يُرحَّل شيء الآن.",
      "ISSUED": "الشيكات الصادرة يقدّمها المورد للبنك."
    },
    "clearBody": {
      "RECEIVED": "صرفه البنك: ينتقل المبلغ من الشيكات برسم التحصيل إلى حساب البنك.",
      "ISSUED": "صرفه البنك: يخرج المبلغ من الحساب البنكي المسحوب عليه."
    },
    "bounceBody": {
      "RECEIVED": "يُلغى سند القبض اعتبارًا من هذا التاريخ، فيعود المبلغ دينًا على العميل. لا يمكن التراجع عن ذلك؛ سجّل شيكًا بديلًا بعده.",
      "ISSUED": "يُلغى سند الدفع اعتبارًا من هذا التاريخ، فيعود المبلغ مستحقًا للمورد. لا يمكن التراجع عن ذلك."
    },
    "returnBody": {
      "RECEIVED": "يُعاد الشيك إلى العميل ويُلغى سند القبض اعتبارًا من هذا التاريخ. لا يمكن التراجع عن ذلك.",
      "ISSUED": "الشيكات الصادرة تُلغى ولا تُعاد."
    },
    "cancelBody": {
      "RECEIVED": "الشيكات الواردة تُعاد للعميل ولا تُلغى.",
      "ISSUED": "أُوقف الشيك أو مُزّق: يُلغى سند الدفع اعتبارًا من هذا التاريخ. لا يمكن التراجع عن ذلك."
    },
    "chargebackBody": {
      "RECEIVED": "صرف البنك هذا الشيك ثم استرد المبلغ. يبقى قيد الصرف كما هو (فقد يكون مطابقًا في كشف حساب بنكي)، ويُسجَّل بهذا التاريخ قيد جديد يُخرج المبلغ من الحساب البنكي، ليُطابَق في الكشف الذي يظهر فيه. ويُلغى سند القبض اعتبارًا من هذا التاريخ، فيعود المبلغ دينًا على العميل. لا يمكن التراجع عن ذلك.",
      "ISSUED": "دفع البنك هذا الشيك ثم أعاد المبلغ إلى الحساب. يبقى قيد الصرف كما هو، ويُسجَّل بهذا التاريخ قيد جديد يعيد المبلغ إلى الحساب البنكي، ليُطابَق في الكشف الذي يظهر فيه. ويُلغى سند الدفع اعتبارًا من هذا التاريخ، فيعود المبلغ مستحقًا للمورد. لا يمكن التراجع عن ذلك."
    },
    "undoBody": {
      "RECEIVED": "يتراجع عن آخر إيداع أو صرف سُجّل خطأً. يُعكس قيد الصرف بتاريخه نفسه.",
      "ISSUED": "يتراجع عن الصرف المسجّل خطأً. يُعكس قيده بتاريخه نفسه."
    },
    "date": {
      "deposit": "تاريخ الإيداع",
      "clear": "تاريخ الصرف",
      "bounce": "تاريخ الارتجاع",
      "return": "تاريخ الإعادة",
      "cancel": "تاريخ الإلغاء",
      "chargeback": "تاريخ الارتجاع"
    },
    "reason": {
      "bounce": "سبب البنك",
      "return": "سبب إعادته",
      "cancel": "سبب إلغائه",
      "chargeback": "سبب البنك",
      "undo": "سبب التراجع"
    },
    "bank": "الحساب البنكي",
    "chooseBank": "اختر حسابًا بنكيًا",
    "reasonShort": "اذكر سببًا (3 أحرف على الأقل)",
    "postDatedHint": "مؤرخ في {{date}}: يقبله البنك ابتداءً من ذلك اليوم.",
    "chargebackHint": "صُرف في {{date}}: يؤرَّخ الارتجاع في ذلك اليوم أو بعده، وبعد آخر كشف بنكي مكتمل."
  },
  "errors": {
    "CHEQUE_STATUS": "تغيّرت حالة هذا الشيك منذ فتح الصفحة. أعد التحميل لترى أين وصل.",
    "CHEQUE_NOT_DUE": "لا يُودَع الشيك ولا يُصرف قبل التاريخ المكتوب عليه.",
    "CHEQUE_CLEARED": "صرف البنك هذا الشيك. من صفحة الشيك، تراجع عن صرفه إن كان خطأً، أو سجّل ارتجاعه بعد الصرف.",
    "SOURCE_REFUNDED": "صُرف استرداد من سند هذا الشيك أو دفعته. أبطِل الاسترداد أولًا.",
    "CUSTOMER_ARCHIVED": "هذا العميل مؤرشف. استعده أولًا: يُلغى سند القبض فيعود المبلغ دينًا عليه.",
    "SUPPLIER_ARCHIVED": "هذا المورد مؤرشف. استعده أولًا: يُلغى سند الدفع فيعود المبلغ مستحقًا له.",
    "BANK_LINE_MATCHED": "قيد صرف هذا الشيك مطابق في كشف الحساب البنكي {{number}}. إن استرد البنك المبلغ فاستخدم «ارتجع بعد الصرف» بدلًا من ذلك؛ أما الصرف المسجّل خطأً فتُلغى مطابقته في الكشف أولًا.",
    "BANK_LINE_MATCHED_completed": "قيد صرف هذا الشيك مطابق في كشف الحساب البنكي {{number}}، وهو كشف مكتمل. إن استرد البنك المبلغ فاستخدم «ارتجع بعد الصرف» بدلًا من ذلك: يبقى الكشف كما هو.",
    "VERSION_CONFLICT": "عدّل شخص آخر هذا الشيك. أعد التحميل وحاول مجددًا."
  },
  "stats": {
    "label": "أرقام الشيكات",
    "cheques_zero": "لا شيكات",
    "cheques_one": "شيك واحد",
    "cheques_two": "شيكان",
    "cheques_few": "{{n}} شيكات",
    "cheques_many": "{{n}} شيكًا",
    "cheques_other": "{{n}} شيك",
    "due": {
      "RECEIVED": "للإيداع",
      "ISSUED": "مستحقة الصرف"
    },
    "week": "تستحق هذا الأسبوع",
    "postDated": "مؤجلة",
    "postDatedDetail": "{{cheques}}، منها {{week}} هذا الأسبوع",
    "atBank": "لدى البنك",
    "atBankLate": "{{cheques}}، تأخر صرف {{late}}",
    "bounced": "مرتجعة، آخر 30 يومًا"
  },
  "empty": {
    "open": "لا شيء ينتظر",
    "cleared": "لا شيكات مصروفة",
    "bounced": "لا شيكات مرتجعة",
    "closed": "لا شيء هنا",
    "all": "لا شيكات بعد"
  },
  "emptyBody": {
    "RECEIVED": "تظهر الشيكات هنا عند تسجيل سند قبض بطريقة الشيك وبيانات الشيك.",
    "ISSUED": "تظهر الشيكات هنا عند تسجيل دفعة لمورد بطريقة الشيك وبيانات الشيك."
  },
  "closed": {
    "BOUNCED": {
      "title": "ارتجع في {{date}}",
      "body": {
        "RECEIVED": "أُلغي سند القبض {{number}}: عاد المبلغ دينًا على العميل.",
        "ISSUED": "أُلغي سند الدفع {{number}}: عاد المبلغ مستحقًا للمورد."
      }
    },
    "CHARGEBACK": {
      "title": "ارتجع بعد الصرف في {{date}}",
      "body": {
        "RECEIVED": "صُرف في {{cleared}} ويبقى قيد صرفه كما هو، والارتجاع حركة مستقلة على الحساب البنكي. أُلغي سند القبض {{number}}: عاد المبلغ دينًا على العميل.",
        "ISSUED": "صُرف في {{cleared}} ويبقى قيد صرفه كما هو، والارتجاع حركة مستقلة على الحساب البنكي. أُلغي سند الدفع {{number}}: عاد المبلغ مستحقًا للمورد."
      }
    },
    "RETURNED": {
      "title": "أُعيد في {{date}}",
      "body": {
        "RECEIVED": "أُلغي سند القبض {{number}}.",
        "ISSUED": "أُلغي سند الدفع {{number}}."
      }
    },
    "CANCELLED": {
      "title": "أُلغي في {{date}}",
      "body": {
        "RECEIVED": "أُلغي سند القبض {{number}}.",
        "ISSUED": "أُلغي سند الدفع {{number}}."
      }
    }
  },
  "replace": {
    "title": "البديل",
    "received": "استلام شيك بديل",
    "issued": "تحرير شيك بديل",
    "replaces": "بديل عن الشيك",
    "replacedBy": "استُبدل بالشيك"
  },
  "timeline": {
    "title": "ما جرى للشيك",
    "by": "بواسطة {{name}}، {{at}}",
    "entry": "قيد اليومية",
    "RECEIVED": {
      "RECEIVED": "استُلم مع سند القبض",
      "ISSUED": "استُلم"
    },
    "ISSUED": {
      "RECEIVED": "صدر",
      "ISSUED": "حُرّر مع سند الدفع"
    },
    "DEPOSITED": {
      "RECEIVED": "أُودِع في {{account}}",
      "ISSUED": "أُودِع في {{account}}"
    },
    "CLEARED": {
      "RECEIVED": "صُرف: دفعه البنك",
      "ISSUED": "صُرف: دفعه البنك من الحساب"
    },
    "BOUNCED": {
      "RECEIVED": "ارتجع: أُلغي سند القبض",
      "ISSUED": "ارتجع: أُلغي سند الدفع"
    },
    "RETURNED": {
      "RECEIVED": "أُعيد للعميل: أُلغي سند القبض",
      "ISSUED": "أُعيد"
    },
    "CANCELLED": {
      "RECEIVED": "أُلغي: أُلغي سند القبض",
      "ISSUED": "أُلغي: أُلغي سند الدفع"
    },
    "CHARGEBACK": {
      "RECEIVED": "ارتجع بعد الصرف: أُلغي سند القبض",
      "ISSUED": "ارتجع بعد الصرف: أُلغي سند الدفع"
    },
    "UNDONE": {
      "RECEIVED": "تم التراجع عن آخر خطوة",
      "ISSUED": "تم التراجع عن آخر خطوة"
    }
  },
  "notes": {
    "title": "ملاحظات المتابعة",
    "add": "إضافة",
    "saved": "حُفظت الملاحظات",
    "none": "لا ملاحظات"
  },
  "capture": {
    "title": "الشيك",
    "description": "يُتابَع حتى يصرفه البنك: يبقى المبلغ برسم التحصيل إلى ذلك الحين.",
    "descriptionIssued": "يُتابَع حتى يصرفه البنك: يبقى المبلغ مستحقًا ضمن الشيكات الصادرة إلى ذلك الحين.",
    "number": "رقم الشيك",
    "bank": "مسحوب على (البنك)",
    "date": "تاريخ الشيك",
    "postDated": "شيك مؤجل: يقبله البنك ابتداءً من {{date}}.",
    "drawnOn": "مسحوب على {{account}}.",
    "needsBank": "يُحرَّر الشيك على حساب بنكي: اختر واحدًا أعلاه.",
    "replaces": "بديل عن الشيك المرتجع {{number}}",
    "dropReplaces": "ليس بديلًا",
    "bouncedBefore_zero": "لم يرتجع أي شيك لهذا العميل من قبل.",
    "bouncedBefore_one": "ارتجع شيك واحد لهذا العميل من قبل (في {{date}}).",
    "bouncedBefore_two": "ارتجع شيكان لهذا العميل من قبل (آخرهما في {{date}}).",
    "bouncedBefore_few": "ارتجعت {{n}} شيكات لهذا العميل من قبل (آخرها في {{date}}).",
    "bouncedBefore_many": "ارتجع {{n}} شيكًا لهذا العميل من قبل (آخرها في {{date}}).",
    "bouncedBefore_other": "ارتجع {{n}} شيك لهذا العميل من قبل (آخرها في {{date}}).",
    "see": "عرض"
  },
  "card": {
    "title": "الشيك",
    "open": "فتح الشيك"
  },
  "customerTab": {
    "title": "الشيكات",
    "figures": "شيكات العميل",
    "register": "فتح في سجل الشيكات",
    "bouncedEver": "المرتجعة، منذ البداية",
    "empty": "لا شيكات من هذا العميل",
    "emptyBody": "تظهر هنا سندات القبض بالشيك مع بيانات الشيك، وما آل إليه كل شيك.",
    "list": "شيكات العميل، الأحدث أولًا"
  }
}
